export default {
    step1: 0,
    step2: 1,
    step3: 2,
    step4: 3,
};
